const AtmosphereForm = ({}) => {
	return <div>AtmosphereForm</div>;
};
export default AtmosphereForm;
